'use strict';

/* $ */
/* _ */
/* Backbone */
/* global Marionette */

/**
 * Класс для кнопки в Корзину
 */
class CalculatorBuy extends Marionette.View {
    template(){
        return false;
    }
    tagName(){
        return 'button';
    }
    className(){
        return 'btn m--orange m--rounded';
    }
    events() {
        return {
            'click': '_addToBasket',
        };
    }
    modelEvents() {
        return {
            'change:can_add_to_basket': '_checkEnabledState',
            'is:ready': '_onReady'
        };
    }
    onRender() {
        let self = this;
        self._onReady();
    }
    _onReady() {
        let self = this;
        self._checkEnabledState();
        self._checkInBasketState();
    }
    _addToBasket(){
        let self = this;
        if((self.model.get('can_add_to_basket')) && (self.model.get('count') > 0)){
            self.triggerMethod('addToBasket:view');
        }
    }
    _checkEnabledState() {
        let self = this;
        if(self.model.get('can_add_to_basket')){
            self.$el.removeClass('is-disabled');
        } else {
            self.$el.addClass('is-disabled');
        }
    }
    _checkInBasketState() {
        let self = this;
        if(self.model.get('is_in_basket')){
            self.$el.text('Изменить');
        }else{
            self.$el.text('В корзину');
        }
    }
}

export {
    CalculatorBuy
};

